import { app } from '../../../../../../../bootstrap/core';

import { confirmWarrantPersonComponent } from './person.component';

app.component(
  confirmWarrantPersonComponent.name,
  confirmWarrantPersonComponent,
);
